import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Puzzle } from "lucide-react";   // ⬅️ CORRECTO

export default function TermsFull() {

  useEffect(() => {
    document.title = "Políticas de Uso y Privacidad – TEAnimo";
  }, []);

  return (
    <>
      {/* HEADER */}
      <header className="w-full bg-gradient-to-r from-blue-50 to-purple-50 p-4 md:p-6">
        <div className="container mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <Puzzle className="h-8 w-8 text-blue-600" />  {/* ⬅️ ICONO CORRECTO */}
            <span className="text-2xl font-bold text-blue-700">
              TEA<span className="text-purple-600">nimo</span>
            </span>
          </Link>
        </div>
      </header>

      {/* CONTENIDO PRINCIPAL */}
      <div className="max-w-4xl mx-auto p-8">
        
        <h1 className="text-3xl font-bold text-blue-800 mb-6">
          Políticas de Uso y Privacidad – TEAnimo
        </h1>

        <p className="text-gray-700 mb-4">
          En TEAnimo nos comprometemos a proteger la privacidad, seguridad y confidencialidad de la información personal...
        </p>

        <h2 className="text-2xl font-bold mt-6 mb-3">1. Fundamentación legal</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          <li>Constitución Política del Perú (Art. 2 – incisos 5 y 6).</li>
          <li>Ley N.º 29733 – Ley de Protección de Datos Personales y su Reglamento (D.S. 003-2013-JUS).</li>
          <li>Código de Protección y Defensa del Consumidor (Ley 29571).</li>
          <li>Reglamento General de Protección de Datos (GDPR – UE 2016/679).</li>
        </ul>

        <h2 className="text-2xl font-bold mt-6 mb-3">2. Consentimiento informado</h2>
        <p className="text-gray-700 mb-4">
          Antes de iniciar cualquier evaluación en la plataforma, el usuario deberá aceptar expresamente el uso y tratamiento de los datos personales conforme a esta Política.
        </p>
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          <li>En caso de que el usuario no otorgue su consentimiento, no será posible realizar la evaluación.</li>
          <li>La aceptación implica que el usuario comprende los fines del tratamiento de los datos y que se le ha informado sobre sus derechos.</li>
          <li>El consentimiento podrá ser retirado en cualquier momento mediante solicitud escrita a nuestros canales oficiales de contacto.</li>
        </ul>

        <h2 className="text-2xl font-bold mt-6 mb-3">3. Uso de la información</h2>
        <p className="text-gray-700 mb-4">
          La información recopilada a través de la plataforma será utilizada únicamente para los siguientes fines:
        </p>
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          <li>Evaluación y resultados: generar reportes y recomendaciones orientativas relacionadas al Trastorno del Espectro Autista (TEA).</li>
          <li>Mejora del servicio: optimizar la experiencia del usuario y perfeccionar los algoritmos de evaluación, garantizando siempre la confidencialidad.</li>
          <li>Comunicación controlada: enviar informes personalizados únicamente al correo electrónico proporcionado por el usuario.</li>
          <li>Investigación y análisis: de manera agregada y anonimizada, los datos podrán contribuir a estudios académicos y científicos sobre TEA.</li>
        </ul>
        <p className="text-gray-700 mb-4">
          En ningún caso los datos serán vendidos, cedidos ni transferidos a terceros sin el consentimiento previo y expreso del usuario.
        </p>

        <h2 className="text-2xl font-bold mt-6 mb-3">4. Protección de datos personales</h2>
        <p className="text-gray-700 mb-4">
          TEAnimo adopta medidas de seguridad administrativas, técnicas y organizativas para garantizar la confidencialidad, integridad y disponibilidad de los datos:
        </p>
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          <li>Los datos se procesan bajo protocolos de anonimización y seudonimización, evitando la identificación directa del menor.</li>
          <li>El almacenamiento temporal de datos se realiza en servidores seguros con cifrado avanzado.</li>
          <li>El acceso a la información está restringido únicamente a personal autorizado y sujeto a deberes de confidencialidad.</li>
          <li>Se aplican buenas prácticas de ciberseguridad basadas en normas internacionales como ISO/IEC 27001.</li>
        </ul>

        <h2 className="text-2xl font-bold mt-6 mb-3">5. Derechos del usuario</h2>
        <p className="text-gray-700 mb-4">
          Conforme a la Ley N.º 29733 y al GDPR, los usuarios pueden ejercer los siguientes derechos ARCO:
        </p>
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          <li>Acceso: conocer qué datos personales han sido recopilados y bajo qué condiciones.</li>
          <li>Rectificación: solicitar la corrección de información errónea o desactualizada.</li>
          <li>Cancelación: pedir la eliminación de sus datos personales cuando no sean necesarios para los fines autorizados.</li>
          <li>Oposición: negarse a que sus datos sean utilizados para ciertos fines específicos.</li>
        </ul>
        <p className="text-gray-700 mb-4">
          El ejercicio de estos derechos se podrá realizar mediante solicitud a los canales de contacto indicados en la plataforma.
        </p>

        <h2 className="text-2xl font-bold mt-6 mb-3">6. Limitaciones</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          <li>Los informes y recomendaciones de TEAnimo son de carácter orientativo y educativo.</li>
          <li>En ningún caso constituyen un diagnóstico médico ni reemplazan la valoración profesional especializada.</li>
          <li>Se recomienda siempre la consulta con un pediatra, psicólogo, neurólogo infantil o especialista en desarrollo para confirmar o descartar riesgos relacionados al TEA.</li>
        </ul>

        <h2 className="text-2xl font-bold mt-6 mb-3">7. Modificaciones</h2>
        <p className="text-gray-700 mb-4">
          TEAnimo se reserva el derecho de actualizar o modificar la presente política en cualquier momento, comunicando dichos cambios a través de la propia plataforma. La versión vigente estará siempre disponible en la sección de Políticas de Uso y Privacidad.
        </p>
      </div>
    </>
  );
}
